import { useMemo } from 'react'

import {
  groupPropertyRates,
  type GroupedPropertyRate,
} from 'lib/property/groupPropertyRates'

export type { GroupedPropertyRate } from 'lib/property/groupPropertyRates'

function useGroupedPropertyRates(
  rates: Array<App.PropertyRate>,
  isLoyaltyProgramFeatureFlagEnabled: boolean,
  sabreHotelsEnabled: boolean,
): Array<GroupedPropertyRate> {
  return useMemo(
    () => groupPropertyRates(rates, isLoyaltyProgramFeatureFlagEnabled, sabreHotelsEnabled),
    [rates, isLoyaltyProgramFeatureFlagEnabled, sabreHotelsEnabled],
  )
}

export default useGroupedPropertyRates
